import React from 'react';

import { ProductDetails } from 'components/ProductLists';

const DetailLayout = () => <ProductDetails />;

export default DetailLayout;
